class StateChangeClient {
    _subscriptionService;
    emptyState;
    constructor(_subscriptionService, emptyState){
        this._subscriptionService = _subscriptionService;
        this.emptyState = emptyState;
    }
    onStateChange = (callback)=>{
        return this._subscriptionService.subscribeToState((state)=>{
            callback(state ?? this.emptyState);
        });
    };
}

export { StateChangeClient };
//# sourceMappingURL=StateChangeClient.mjs.map
